import Pager from './Pager'

export default Pager
// eslint-disable-next-line import/export
export * from './Pager'
